const fv__swiper = new Swiper(".fv__swiper", {
  // ページネーション
  pagination: {
    el: ".fv__swiper-pagination",
    clickable: true, // クリック有効化
  },
  on: {
    init: function () {
      updateButton(this);
    },
    slideChange: function () {
      updateButton(this);
    }
  }
});
function updateButton(swiper) {
  const activeSlide = swiper.slides[swiper.activeIndex];
  const url = activeSlide.dataset.url;
  const button = document.getElementById('fv-buy-button');

  if (url && button) {
    button.setAttribute('href', url);
  }
};

const lineup__swiper = new Swiper(".lineup__swiper", {
  // ページネーション
  pagination: {
    el: ".lineup__swiper-pagination",
    clickable: true, // クリック有効化
  },
    navigation: {
    nextEl: ".lineup__swiper-button-next",
    prevEl: ".lineup__swiper-button-prev",
  },
    breakpoints: {
    // スライドの表示枚数：1000px以上の場合
    1000: {
      slidesPerView: 3,
    },
  },
});

const sceneSwiper = new Swiper(".scene__swiper", {
  speed: 800,
  spaceBetween: 20,

  slidesPerView: 1.22, // SP

  pagination: {
    el: ".scene__swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".scene__swiper-button-next",
    prevEl: ".scene__swiper-button-prev",
  },

  breakpoints: {
    1000: {
      slidesPerView: 3,
      centeredSlides: true,
      initialSlide: 1,
      allowTouchMove: false,
    },
  },

  on: {
    // translate補正（PCだけ）
    setTranslate(swiper, translate) {
      if (window.innerWidth >= 1000) {
        swiper.wrapperEl.style.transform =
          `translate3d(${translate - swiper.width / 6}px, 0, 0)`;
      }
    },
    slideChange(sw) {
      if (window.innerWidth >= 1000) {
        const lastIndex = sw.slides.length - 1;
        if (sw.activeIndex === lastIndex) {
          // 最後に行こうとしたら一つ前へ戻す（速度0で瞬間）
          sw.slideTo(lastIndex - 1, 0);
        }
      }
    },

    // ✅ 初期表示のズレ対策
    init(swiper) {
      // 1フレーム遅らせてから再計算→目的位置へ
      requestAnimationFrame(() => {
        swiper.update();

        if (window.innerWidth >= 1000) {
          // loop:false 前提（loop:trueなら slideToLoop(1, 0)）
          swiper.slideTo(1, 0);
        }
      });
    },

    // ✅ breakpoint切替時もズレやすいので補正
    breakpoint(swiper) {
      requestAnimationFrame(() => {
        swiper.update();

        if (window.innerWidth >= 1000) {
          swiper.slideTo(1, 0);
        }
      });
    },
  },
});


const plan__swiper = new Swiper(".plan__swiper", {
  speed: 800,
  slidesPerView: 1.25, // 一度に表示する枚数
  spaceBetween: 12, // スライド間の距離
  centeredSlides: true, // アクティブなスライドを中央にする
  // ページネーション
  pagination: {
    el: ".plan__swiper-pagination",
    clickable: true, // クリック有効化
  },
    navigation: {
    nextEl: ".plan__swiper-button-next",
    prevEl: ".plan__swiper-button-prev",
  },
  breakpoints: {
    // スライドの表示枚数：1000px以上の場合
    1000: {
      slidesPerView: 3,
    },
  },
});



// 3ステップタブ切り替え

$(function () {
  $('.step__tab').on('click', function () {
    const target = $(this).data('tab');

    // タブ切り替え
    $('.step__tab').removeClass('step__tab-active');
    $(this).addClass('step__tab-active');

    // コンテンツ切り替え
    $('.step__tab-content')
      .removeClass('step__tab-content-active');
    $('#' + target)
      .addClass('step__tab-content-active');
  });
});

// 料金表タブ切り替え

$(function () {
  $('.price__tab').on('click', function () {
    const target = $(this).data('tab');
    const $priceList = $(this).closest('[class*="price__price-list"]');

    // タブ切り替え（同じprice__price-list内のみ）
    $priceList.find('.price__tab').removeClass('price__tab-active');
    $(this).addClass('price__tab-active');

    // コンテンツ切り替え（同じprice__price-list内のみ）
    $priceList.find('.price__tab-content').removeClass('price__tab-content-active');
    $('#' + target).addClass('price__tab-content-active');
  });
});


// バリアント切替時にvariant_descriptionを更新
document.addEventListener('variant:change', function (e) {
  const variant = e.detail.variant;
  const el = document.querySelector('[data-variant-description]');
  if (!el || !variant) return;

  const descriptions = el.dataset.descriptions;
  const map = {};
  descriptions.split(',').forEach(function (pair) {
    const idx = pair.indexOf(':');
    if (idx > -1) {
      map[pair.substring(0, idx)] = pair.substring(idx + 1);
    }
  });

  el.textContent = map[variant.id] || '';
});

// よくある質問（アコーディオン）
$(function () {
  $('.faq__item').on('click', function () {
    $(this).find('.faq__answer').slideToggle(200);
    $(this).toggleClass('is-open');
  });
});


// ナビゲーション アコーディオン
$(function () {
  $('.nav-accordion__toggle').on('click', function () {
    const $item = $(this).closest('.nav-accordion__item');
    const $subList = $item.find('.nav-accordion__sub-list');
    const isOpen = $item.hasClass('is-open');

    // アコーディオン開閉アニメーション
    if (isOpen) {
      $subList.slideUp(250);
      $item.removeClass('is-open');
    } else {
      $subList.slideDown(250);
      $item.addClass('is-open');
    }

    // aria属性
    $(this).attr('aria-expanded', !isOpen);
  });
});

// SPメニュー表示

$(function () {
  $('#header-sidebar-menu').on('click', 'a', function () {
    const drawerEl = document.getElementById('header-sidebar-menu');
    if (drawerEl && typeof drawerEl.hide === 'function') {
      drawerEl.hide();
    }
  });
});

// 支払い方法タブ切り替え
$(function () {
  // 初期状態：最初のタブのみactive
  $('.payment__cards-tab').first().addClass('active');
  $('.payment__tab-card').removeClass('active').first().addClass('active');

  $('.payment__cards-tab').on('click', function () {
    var target = $(this).data('target');

    // タブボタン切替
    $('.payment__cards-tab').removeClass('active');
    $(this).addClass('active');

    // コンテンツ切替
    $('.payment__tab-card').removeClass('active');
    // data-targetはcard-mark-boxのIDなので、そこから親のtab-cardを探す
    $('#' + target).closest('.payment__tab-card').addClass('active');
  });
});

//ハンバーガーメニューアイコン

$(function () {
  const drawerEl = document.getElementById('header-sidebar-menu');

  if (drawerEl) {
    // 初期状態（ドロワーが開いていたら反映）
    if (drawerEl.hasAttribute('open')) {
      $('.header__icon-list .hamburger').addClass('is-open');
      $('.header__icon-list .close').addClass('is-open');
    }

    // ドロワーが開いた後にアイコンをクローズ表示へ
    drawerEl.addEventListener('dialog:after-show', function () {
      $('.header__icon-list .hamburger').addClass('is-open');
      $('.header__icon-list .close').addClass('is-open');
    });

    // ドロワーが閉じた後にアイコンをハンバーガー表示へ
    drawerEl.addEventListener('dialog:after-hide', function () {
      $('.header__icon-list .hamburger').removeClass('is-open');
      $('.header__icon-list .close').removeClass('is-open');
    });
  }
});

// 商品一覧カードのAjaxカート追加
document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.js-ajax-add-to-cart');
  if (!btn || btn.disabled) return;
  e.preventDefault();

  const variantId = btn.dataset.variantId;
  const defaultText = btn.dataset.defaultText || btn.textContent.trim();

  btn.disabled = true;
  btn.classList.add('is-loading');
  btn.innerHTML = '<span class="c-spinner" aria-hidden="true"></span><span class="sr-only">追加中</span>';

  try {
    const sections = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sections }
    }));

    const formData = new FormData();
    formData.set('id', variantId);
    formData.set('quantity', 1);
    formData.set('sections', sections.join(','));
    formData.set('sections_url', `/variants/${variantId}`);

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    });

    if (!res.ok) throw new Error('add failed');

    const responseJson = await res.json();
    const cartContent = await (await fetch('/cart.js')).json();
    cartContent['sections'] = responseJson['sections'];

    document.dispatchEvent(new CustomEvent('variant:add', {
      bubbles: true,
      detail: {
        items: responseJson.hasOwnProperty('items') ? responseJson['items'] : [responseJson],
        cart: cartContent
      }
    }));

    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: {
        baseEvent: 'variant:add',
        cart: cartContent
      }
    }));

    btn.classList.remove('is-loading');
    btn.textContent = '追加しました ✓';
    setTimeout(function () {
      btn.textContent = defaultText;
      btn.disabled = false;
    }, 2000);
  } catch (err) {
    btn.classList.remove('is-loading');
    btn.textContent = '追加に失敗しました';
    setTimeout(function () {
      btn.textContent = defaultText;
      btn.disabled = false;
    }, 2000);
  }
});